import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ab7d16f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3ab7d16f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7d16f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab7d16f')) {
      api.createRecord('3ab7d16f', component.options)
    } else {
      api.reload('3ab7d16f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ab7d16f&scoped=true", function () {
      api.rerender('3ab7d16f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/marking-exampaper/index.vue"
export default component.exports